import { atom, atomFamily, selector } from 'recoil';

export const accountInfo = atom({
    key: 'accountInfo',
    default: null
})